import Input from '../Input/Input';
import DropDownInput from '../DropDownInput/DropDownInput';
import MedImage from '../MedImage/MedImage';
import MedInfoCard from '../MedInfoCard/MedInfoCard';
import Loader from '../Loader/Loader';
import Modal from '../Modal/Modal';
import { useMedCard } from '../../hooks/Medic/useMedCard';
import './medcard.css';
import { statusMap } from '../../types/type';

function MedCard() {
  const {
    formData,
    error,
    loading,
    showReasonModal,
    reasonForRefusal,
    handleChange,
    handleStatusChange,
    handleReasonSubmit,
    setShowReasonModal,
    setReasonForRefusal,
  } = useMedCard();

  return (
    <div className="profile__card">
      <MedImage user_avatar={formData.avatar} user_selfie={formData.selfie} profileId={formData.driverProfileId} />
      <div className="info__card">
        <Loader isLoading={loading} />
        <div className="info__card-header">
          <div className="info__card-header__title">Медицинская информация</div>
          <div className="info__card-header__descr">
            <span
              className={`dot ${
                formData.status === 'completed'
                  ? 'active'
                  : formData.status === 'waiting'
                    ? 'waiting'
                    : formData.status === 'inProgress'
                      ? 'inProgress'
                      : 'rejected'
              } `}
            ></span>
            {statusMap[formData.status as keyof typeof statusMap]}
          </div>
        </div>
        <div className="info__card-body __driver">
          <Input
            type="date"
            label="Дата"
            id="date"
            value={formData.date}
            editable={false}
            style={{ gridColumn: '1/2' }}
          />

          <DropDownInput
            items={[
              { text: 'Положительно', value: 'completed' },
              { text: 'Отрицательно', value: 'rejected' },
              { text: 'Ждет контроля', value: 'waiting' },
              { text: 'В процессе', value: 'inProgress' },
            ]}
            onSelect={(value) => handleStatusChange(value)}
            initialValue={formData.status}
            editable={formData.status === 'waiting' || formData.status === 'inProgress'}
            // editable={true}
            disableSelect={formData.lament}
            style={{ gridColumn: '2/4' }}
          />
          <Input
            type="time"
            label="Время"
            id="time"
            value={formData.time}
            editable={false}
            style={{ gridColumn: '1/2' }}
          />
          <Input
            label="Номер заявки"
            id="num"
            value={formData.num}
            editable={false}
            style={{ gridColumn: '2/3', width: '100%' }}
          />

          {/* <Input label="ФИО" id="fullName" value={formData.fullName} editable={false} style={{ gridColumn: '1/2' }} /> */}
          {formData.autopark && (
            <Input
              label="Автопарк"
              id="autopark"
              value={formData.autopark}
              editable={false}
              style={{ gridColumn: '1/2' }}
            />
          )}

          <Input
            label="Пол"
            id="gender"
            value={formData.sex === 'male' ? 'Мужской' : formData?.sex === 'female' ? 'Женский' : ''}
            editable={false}
            style={{ gridColumn: '1/2' }}
          />

          <Input
            type="date"
            label="Дата рождения"
            id="birthday"
            value={formData.birthDate}
            editable={false}
            style={{ gridColumn: '1/2' }}
          />

          <Input
            label="Температура"
            id="temperature"
            type="number"
            value={formData.temperature}
            onChange={(e) => handleChange('temperature', e.target.value)}
            editable={formData.status === 'waiting' || formData.status === 'inProgress'}
            style={{ gridColumn: '1/2' }}
          />
          {error.temperature && <span className="error">{error.temperature}</span>}

          <Input
            label="Давление"
            id="bloodPressure"
            type="string"
            value={formData.bloodPressure}
            onChange={(e) => handleChange('bloodPressure', e.target.value)}
            editable={formData.status === 'waiting' || formData.status === 'inProgress'}
            style={{ gridColumn: '1/2' }}
          />
          {error.bloodPressure && <span className="error">{error.bloodPressure}</span>}

          <Input
            label="Пульс"
            id="pulse"
            type="number"
            value={formData.pulse}
            onChange={(e) => handleChange('pulse', e.target.value)}
            editable={formData.status === 'waiting' || formData.status === 'inProgress'}
            style={{ gridColumn: '1/2' }}
          />
          {error.pulse && <span className="error">{error.pulse}</span>}

          <Input
            label="Промилле"
            id="promile"
            type="number"
            value={formData.promile}
            onChange={(e) => handleChange('promile', e.target.value)}
            editable={formData.status === 'waiting' || formData.status === 'inProgress'}
            style={{ gridColumn: '1/2' }}
          />
          {error.promile && <span className="error">{error.promile}</span>}

          <Input
            label="Жалобы на здоровье"
            id=""
            value={formData.lament ? 'Есть' : 'Нет'}
            editable={false}
            style={{ gridColumn: '1/2' }}
          />
        </div>
      </div>

      {showReasonModal && (
        <Modal title="Обоснование отрицательного заключения" onClose={() => setShowReasonModal(false)}>
          <div className="modal-content">
            <div className="modal-form-group">
              <div className="modal-label">Укажите причину отказа:</div>
              <textarea
                rows={5}
                className="modal-textarea"
                value={reasonForRefusal}
                onChange={(e) => setReasonForRefusal(e.target.value)}
              />
            </div>
            <div className="modal-actions">
              <button onClick={() => setShowReasonModal(false)} className="modal-button modal-button-cancel">
                Отмена
              </button>
              <button
                onClick={handleReasonSubmit}
                className="modal-button modal-button-confirm"
                disabled={!reasonForRefusal.trim()}
              >
                Подтвердить
              </button>
            </div>
          </div>
        </Modal>
      )}

      <MedInfoCard driverProfileId={formData.driverProfileId} />
    </div>
  );
}

export default MedCard;
